import React from 'react'

export default function Stroke({ strokeSize, onStrokeSizeChange }) {
    const handleSymmetry = (p) => {
        if (p === 'down') {
            onStrokeSizeChange(strokeSize=strokeSize+1)
        } else {
            onStrokeSizeChange(strokeSize=strokeSize-1)
        }
    }
  
  return (
    <div className="mb-4 hide-mobile">
        <span className='label'>Stroke size</span>
        {strokeSize < 2 ? ' ' : <button onClick={() => {handleSymmetry('up')}} className='bg-green-500 hover:bg-darkgreen-700 text-white font-bold py-2 px-2 mx-2 rounded'>-</button>}
        <span className='label'>{strokeSize}</span>
        {strokeSize > 5 ? ' ' : <button onClick={() => {handleSymmetry('down')}} className='bg-green-500 hover:bg-darkgreen-700 text-white font-bold py-2 px-2 rounded'>+</button>}
        
    </div>

  )
}
